import React from 'react';
import styled from 'styled-components';
import { ReactComponent as CloseIcon } from '@ubeya/shared-web/assets/close-big.svg';
import { CircleIcon, Modal as BaseModal } from '@ubeya/shared-web/components';
import Calendly from '../Calendly';

const Modal = styled(BaseModal)`
  max-height: 700px;
  padding-bottom: 10px;
  max-width: 420px;
  position: relative;

  > .title {
    border: none;
    padding: 22px 30px 0;
    align-items: flex-end;
  }

  .circle-icon {
    right: 2px;
    top: 2px;
    position: absolute;
  }
`;

const DemoModal = ({ onClose }) => (
  <Modal onClose={onClose} showConfirmButton={false} isPaddingContent={false}>
    <CircleIcon icon={CloseIcon} onClick={onClose} />
    <Calendly url="https://meetings.hubspot.com/omri10/round-robin" />
  </Modal>
);

export default DemoModal;
